function calcAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

function checkAge(e) {
    e.preventDefault();
    var modal = document.getElementsByClassName('js-verified-modal');
    var ageChecked = document.getElementById('age-checked');
    const data = Object.fromEntries(new FormData(e.target).entries()); 
    var  date = `${data.year}/${data.month}/${data.day}`;
    
    if(calcAge(date) >= 18 || getAgeCookie() === 'true' ){
      //close first modal available in your page
      closeModal(modal[0]);
      if(getAgeCookie() === 'true')return
      createAgeCookie();
    } else {
        alert('You are not old enough to purchase alcohol');
    };
    
}

function closeModal(element) {
  var event = new CustomEvent('closeModal');
  element.dispatchEvent(event);
};

function openModal(element) {
    var event = new CustomEvent('openModal');
    element.dispatchEvent(event);
    console.log('firedOpenModal');
   
};

function createAgeCookie(){
    document.cookie = 'ageChecked=true; path=/';
    console.log('created cookie');
}

function getAgeCookie(){
    return document.cookie
    .split('; ')
    .find((row) => row.startsWith('ageChecked='))
    ?.split('=')[1];
}



document.addEventListener('DOMContentLoaded', function(){

  if(getAgeCookie() === undefined ){
    var modal = document.getElementsByClassName('js-verified-modal');
    console.log(modal);
    openModal(modal[0]);
    console.log('true');
  }

}, false);



var form = document.getElementById('age-verification-form');

form.addEventListener('submit', checkAge);